export function generateRelaySlug() {
    const a = new Uint8Array(8);
    crypto.getRandomValues(a);
    return Array.from(a, (x) => x.toString(16).padStart(2, '0')).join('');
}

export function isValidRelaySlug(slug) {
    return typeof slug === 'string' && /^[a-f0-9]{16}$/i.test(slug);
}
